import React from 'react';
import { usePermission } from '../hooks/usePermission';
import { Alert } from '@mui/material';

/**
 * Component wrapper that conditionally renders children based on permissions
 * @param {string|string[]} permission - Required permission(s)
 * @param {string} mode - 'any' or 'all' for array permissions
 * @param {boolean} showDenied - Show access denied message instead of hiding
 * @param {React.ReactNode} fallback - Custom fallback component
 * @param {React.ReactNode} children - Content to render if permission granted
 */
const PermissionGuard = ({
  permission,
  mode = 'any',
  showDenied = false,
  fallback = null,
  children
}) => {
  const hasPermission = usePermission(permission, mode);

  if (hasPermission) {
    return <>{children}</>;
  }

  if (showDenied) {
    return fallback || (
      <Alert severity="warning">
        You don't have permission to access this feature.
      </Alert>
    );
  }

  return null;
};

export default PermissionGuard;
